<template>
    <b-modal
            v-model="modal.state"
            @hidden="hideModal"
            modal-class="filters-modal"
            header-class="align-items-start"
            body-class="p-0"
            centered
            no-close-on-esc
            no-close-on-backdrop
    >
        <template v-slot:modal-header="{ close }">
            <b-button
                    variant="link"
                    class="close"
                    @click="close"
            >
                <i class="fal fa-times" />
            </b-button>
            <h3 class="mb-0">
                Filters
            </h3>
        </template>
        <template v-slot:default>
            <b-card
                v-if="displaySearchInput"
                body-class="d-flex"
                class="border-0"
            >
                <property-search-input
                    class="mx-1 flex-nowrap"
                    @input="handleSearchInput"
                    v-model="searchInputValue"
                />
            </b-card>
            <b-card
                    header="PRICE"
                    header-tag="h4"
                    header-class="rounded-0"
                    body-class="d-flex"
                    class="border-0"
            >
                <range-dropdown
                        class="p-0 mx-auto"
                        v-model="filter.price"
                        :options="FILTER_OPTIONS.PRICES"
                />
            </b-card>
            <b-card
                    header="BEDROOMS"
                    header-tag="h4"
                    header-class="rounded-0"
                    body-class="d-flex"
                    class="border-0"
            >
                <buttons-dropdown
                        class="p-0 w-100"
                        v-model="filter.beds"
                        :options="FILTER_OPTIONS.BEDS"
                />
            </b-card>
            <b-card
                    header="BATHROOMS"
                    header-tag="h4"
                    header-class="rounded-0"
                    body-class="d-flex"
                    class="border-0"
            >
                <buttons-dropdown
                        class="p-0 w-100"
                        v-model="filter.baths"
                        :options="FILTER_OPTIONS.BATHS"
                />
            </b-card>
            <b-card
              header="SQUARE FEET"
              header-tag="h4"
              header-class="rounded-0"
              body-class="d-flex"
              class="border-0"
            >
              <range-dropdown
                  class="p-0 mx-auto"
                  v-model="filter.squareFeet"
                  :options="FILTER_OPTIONS.SQUARE_FEET"
              />
            </b-card>
            <b-card
                    header="HOME TYPE"
                    header-tag="h4"
                    header-class="rounded-0"
                    body-class="d-flex p-0"
                    class="border-0"
            >
                <list-dropdown
                        v-model="filter.homeType"
                        :options="homeTypeOptions"
                />
            </b-card>
            <b-card
                header="LISTING TYPE & STATUS"
                header-tag="h4"
                header-class="rounded-0"
                body-class="d-flex p-0 flex-column"
                class="border-0"
            >
                <div
                    class="list-dropdown"
                    :class="{
                        'border-bottom': !filter.isSold
                    }"
                >
                    <b-form-radio-group
                        v-model="filter.isSold"
                        :options="FILTER_OPTIONS.IS_SOLD"
                        stacked
                    />
                </div>
                <list-dropdown
                    v-if="!filter.isSold"
                    v-model="filter.sale"
                    :options="saleOptions"
                />
                <div class="border-top list-dropdown">
                    <div class="custom-control my-3">
                        <switch-toggle
                            v-model="filter.includePending"
                            label="Pending & Under Contract"
                            label-position="left"
                        />
                    </div>
                </div>
            </b-card>
            <b-card
                header="YEAR BUILT"
                header-tag="h4"
                header-class="rounded-0"
                body-class="d-flex"
                class="border-0"
            >
              <range-dropdown
                  class="p-0 mx-auto"
                  v-model="filter.yearBuilt"
                  :options="FILTER_OPTIONS.YEAR_BUILT"
              />
            </b-card>
            <b-card
                header="LOT SIZE"
                header-tag="h4"
                header-class="rounded-0"
                body-class="d-flex"
                class="border-0"
            >
              <range-dropdown
                  class="p-0 mx-auto"
                  v-model="filter.lotSize"
                  :options="FILTER_OPTIONS.LOT_SIZE"
              />
            </b-card>
            <b-card
                header="KEYWORD"
                header-tag="h4"
                header-class="rounded-0"
                body-class="d-flex"
                class="border-0"
            >
              <keyword-type-ahead
                  class="w-100"
                  v-model="filter.keywords"
                  :options="FILTER_OPTIONS.KEYWORDS"
              />
            </b-card>
        </template>
        <template v-slot:modal-footer>
            <b-button
                    variant="primary"
                    @click="applyFilters"
                    size="lg"
                    block
            >
                Apply
            </b-button>
        </template>
    </b-modal>
</template>

<script>
    import './FiltersModal.scss';
    import {proxyFilter} from "../../../classes/Filter";
    import RangeDropdown
        from "../../GroupPropertySearchHeader/GroupPropertySearchFilters/GroupDropdowns/RangeDropdown/RangeDropdown";
    import ButtonsDropdown
        from "../../GroupPropertySearchHeader/GroupPropertySearchFilters/GroupDropdowns/ButtonsDropdown/ButtonsDropdown";
    import ListDropdown
        from "../../GroupPropertySearchHeader/GroupPropertySearchFilters/GroupDropdowns/ListDropdown/ListDropdown";
    import KeywordTypeAhead
        from "../../GroupPropertySearchHeader/GroupPropertySearchFilters/PropertySearchFilters/KeywordTypeAhead/KeywordTypeAhead";
    import * as FILTER_OPTIONS from '../../../../helpers/filterOptions';
    import cloneDeep from 'lodash/cloneDeep';
    import {debounce} from "lodash/function";
    import PropertySearchInput
        from "../../GroupPropertySearchHeader/PropertySearchHeader/PropertySearchInput/PropertySearchInput";


    export const FILTERS_MODAL_OPEN = 'FILTERS_MODAL_OPEN';

    export default {
        name: "FiltersModal",
        components: {
            PropertySearchInput,
            RangeDropdown,
            ButtonsDropdown,
            ListDropdown,
            KeywordTypeAhead,
        },
        data() {
            return {
                proxyFilter,
                FILTER_OPTIONS,
                modal: {
                    state: false,
                },
                filter: cloneDeep(proxyFilter),
                displaySearchInput: false,
                searchInputValue: {
                    value: null,
                    label: '',
                    field: null,
                },
            };
        },

        computed: {
            saleOptions() {
                let options = [];
                for(let item of this.FILTER_OPTIONS.SALE_TYPES) {
                    options.push({
                        label: item.label,
                        value: item,
                    });
                }
                return options;
            },

            homeTypeOptions() {
                let options = [];
                for (let item of FILTER_OPTIONS.HOME_TYPES) {
                    options.push({
                        label: item.label,
                        value: item,
                    });
                }
                return options;
            },
        },

        methods: {
            init(displaySearchInput = false) {
                this.modal.state = true;
                this.displaySearchInput = displaySearchInput;
            },
            handleSearchInput: debounce(function (searchInput) {
                this.filter.location = null;
                this.filter.search = searchInput.value;
                this.filter.searchLabel = searchInput.label;
                this.searchInputValue.value = searchInput.value;
                this.searchInputValue.label = searchInput.label;
            }, 750),
            applyFilters() {
                if(this.displaySearchInput) {
                    this.proxyFilter.location = this.filter.location;
                    this.proxyFilter.search = this.filter.search;
                    this.proxyFilter.searchLabel = this.filter.searchLabel;
                }
                this.proxyFilter.price = this.filter.price;
                this.proxyFilter.squareFeet = this.filter.squareFeet;
                this.proxyFilter.yearBuilt = this.filter.yearBuilt;
                this.proxyFilter.lotSize = this.filter.lotSize;
                this.proxyFilter.beds = this.filter.beds;
                this.proxyFilter.baths = this.filter.baths;
                this.proxyFilter.homeType = this.filter.homeType;
                this.proxyFilter.sale = this.filter.sale;
                this.proxyFilter.keywords = this.filter.keywords;
                this.proxyFilter.includePending = this.filter.includePending;
                this.hideModal();
            },
            hideModal() {
                this.modal.state = false;
                this.filter = cloneDeep(proxyFilter);
            },
        },
        async mounted() {
            this.$bus.$on(FILTERS_MODAL_OPEN, this.init);
        },
        beforeDestroy() {
            this.$bus.$off(FILTERS_MODAL_OPEN, this.init);
        }
    };
</script>
